import React from 'react'
import './Card.css'
function Card({type,amount,details}) {
  console.log(details)
  return (
    <section className={ type==="Professional" ? 'Card Card-prof' : 'Card Card-default'}>
         <h3 className='font-bold text-center'>{type}</h3>
         <p className='amount'>
             <span className='text-xl mr-2'>$</span>
             {amount}
         </p>
         <ul className='text-center my-6'>
             <li className='list-item'> {details[0].storage} Storage</li>
             <li className='list-item'> {details[0].users} Users Allowed</li>
             <li className='list-item'> Send up to {details[0].send}</li>
         </ul>
         <button 
            className={type === 'Professional' ? 
            'btn-professional btn-dark' 
            : 'btn-light hover:text-secondary-500'}> learn More</button>
    </section>
  )
}

export default Card
